import React from 'react'

import {Tag} from 'antd'

export class TriStateTag extends React.Component {
   static get propTypes() {
      return {
         onChange: React.PropTypes.func.isRequired,
         field:    React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array])
            .isRequired,
         children: React.PropTypes.any
      }
   }

   constructor() {
      super()

      this.state = {
         value: 0
      }

      this.handleChange = this.handleChange.bind(this)
   }

   valToState(value) {
      switch (value) {
         case true:
            return 1
         case false:
            return 2
         case null:
         case undefined:
         default:
            return 0
      }
   }

   stateToVal(state) {
      switch (state % 3) {
         case 0:
            return null
         case 1:
            return true
         case 2:
            return false
         default:
            return null
      }
   }

   handleChange(_ev) {
      const {onChange, field} = this.props

      this.setState({value: (this.state.value + 1) % 3}, () => {
         return onChange(field, this.stateToVal(this.state.value))
      })
   }

   render() {
      let text, color

      switch (this.state.value) {
         case 0:
            text = 'Unchanged'
            color = '#ccc'
            break
         case 1:
            text = 'On'
            color = '#87d068'
            break
         case 2:
            text = 'Off'
            color = '#f50'
            break
         default:
            text = 'Unknown State'
            color = '#000'
            break
      }

      return <Tag color={color} onClick={this.handleChange} title={text}>{this.props.children}</Tag>
   }
}



// WEBPACK FOOTER //
// lib/ui/TriStateTag.jsx